// MIT License - Copyright (c) 2026 Doug McNall

import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

function ChangePassword({ onClose }) {
  const { changePassword } = useAuth();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    try {
      await changePassword(oldPassword, newPassword);
      setSuccess(true);
      setTimeout(() => onClose(), 2000);
    } catch (err) {
      setError(err.message || 'Failed to change password');
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={styles.title}>Change Password</h2>
        
        {success ? (
          <div style={styles.success}>✅ Password changed successfully!</div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="Current Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              style={styles.input}
              required
            />
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={styles.input}
              required
            />
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={styles.input}
              required
            />
            
            {error && <div style={styles.error}>{error}</div>}
            
            <div style={styles.buttons}>
              <button type="button" onClick={onClose} style={styles.cancelBtn}>
                Cancel
              </button>
              <button type="submit" style={styles.submitBtn}>
                Change Password
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000
  },
  modal: {
    background: 'linear-gradient(135deg, rgba(10, 25, 47, 0.95), rgba(20, 35, 57, 0.95))',
    border: '2px solid #00ffff',
    borderRadius: '12px',
    padding: '32px',
    maxWidth: '400px',
    width: '90%',
    boxShadow: '0 0 30px rgba(0, 255, 255, 0.3)'
  },
  title: {
    color: '#00ffff',
    fontFamily: 'Orbitron, sans-serif',
    fontSize: '24px',
    marginBottom: '24px',
    textAlign: 'center'
  },
  input: {
    width: '100%',
    padding: '12px',
    marginBottom: '16px',
    background: 'rgba(0, 0, 0, 0.3)',
    border: '1px solid #00ffff',
    borderRadius: '6px',
    color: '#ffffff',
    fontSize: '16px',
    fontFamily: 'Rajdhani, sans-serif',
    boxSizing: 'border-box'
  },
  error: {
    color: '#ff4444',
    marginBottom: '16px',
    textAlign: 'center'
  },
  success: {
    color: '#00ff88',
    fontSize: '18px',
    textAlign: 'center',
    padding: '20px'
  },
  buttons: {
    display: 'flex',
    gap: '12px',
    marginTop: '24px'
  },
  cancelBtn: {
    flex: 1,
    padding: '12px',
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid #666',
    borderRadius: '6px',
    color: '#ffffff',
    cursor: 'pointer',
    fontFamily: 'Rajdhani, sans-serif',
    fontSize: '16px'
  },
  submitBtn: {
    flex: 1,
    padding: '12px',
    background: 'linear-gradient(135deg, #00ffff, #00ff88)',
    border: 'none',
    borderRadius: '6px',
    color: '#000',
    cursor: 'pointer',
    fontFamily: 'Rajdhani, sans-serif',
    fontSize: '16px',
    fontWeight: '600'
  }
};

export default ChangePassword;
